import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import config from './config';
import { getUser, getVersion, removeUser, setVersion } from './helpers/storage';
import './index.scss';
import { Provider as GlobalProvider, State } from './stores/global';

const appVersion = getVersion();

if (appVersion !== config.version) {
  setVersion(config.version);
  removeUser();
}

const initialState: State = {
  isLoading: false,
  user: getUser(),
};

Sentry.init({
  dsn:
    'https://971e7c031fe345358aeeba8a64788e2b@o956696.ingest.sentry.io/5906100',
  integrations: [new Integrations.BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 0,
});

ReactDOM.render(
  <GlobalProvider initialState={initialState}>
    <App />
  </GlobalProvider>,
  document.getElementById('app-root')
);
